var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOilGas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,30.75H50a.7502.7502,0,0,0,.75-.75V18a.7502.7502,0,0,0-.75-.75H30a.7502.7502,0,0,0-.75.75V30A.7502.7502,0,0,0,30,30.75Zm.75-12h18.5v10.5H30.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63,51.90918a5.56339,5.56339,0,0,0,5.75-5.3418V17.25h-1.5v6.48633l-3.83594,4.79492A.75048.75048,0,0,0,63.25,29v5a.7502.7502,0,0,0,.75.75h3.25V46.56738a4.27169,4.27169,0,0,1-8.5,0V10A.7502.7502,0,0,0,58,9.25H21.63281a.7502.7502,0,0,0-.75.75V69.25H11.69922v1.5H68.30078v-1.5H58.75V50.15283A5.93267,5.93267,0,0,0,63,51.90918ZM64.75,33.25V29.2627l2.5-3.125V33.25Zm-7.5,12.56738V69.25H22.38281V10.75H57.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.25,
    y: 35.25,
    width: 21.5,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOilGas);
export default __webpack_public_path__ + "static/media/icon_oil_gas.0db2ad4627aa2927291f307213446ade.svg";
export { ForwardRef as ReactComponent };